import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=125d5778&scoped=true&"
import script from "./verify.vue?vue&type=script&lang=js&"
export * from "./verify.vue?vue&type=script&lang=js&"
import style0 from "./verify.vue?vue&type=style&index=0&id=125d5778&lang=scss&scoped=true&"
import style1 from "./verify.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d5778",
  null
  
)

/* custom blocks */
import block0 from "./verify.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports